export default __webpack_public_path__ + "static/media/hexagon.0295f58a.svg";